import type { AuiRendererProps } from '../registry';

export function AuiRow({ node, children }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const rawGap = props.gap;
  const gap = typeof rawGap === 'number' ? rawGap : undefined;
  const align = (props.align as string) ?? 'start';
  const justify = (props.justify as string) ?? 'start';

  const alignMap: Record<string, string> = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    stretch: 'stretch',
  };

  const justifyMap: Record<string, string> = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    between: 'space-between',
    around: 'space-around',
  };

  return (
    <div
      className="flex flex-row flex-wrap"
      style={{
        gap: `${(gap ?? 4) * 0.25}rem`,
        alignItems: alignMap[align] ?? 'center',
        justifyContent: justifyMap[justify] ?? 'flex-start',
      }}
      data-testid="aui-row"
    >
      {children}
    </div>
  );
}
